import { ButlerContextProps, CurrentUser } from '../../utils/butlerContext';

const loadData = async (client_id: number, currentUser: CurrentUser, butlerContext: ButlerContextProps) => {
  const client = await butlerContext.clientService.getClient(client_id);
  const profiles = await butlerContext.profileService.getUsers();
  return { client, profiles };
};

export default loadData;
